import React from 'react';
import { ActivityIcon, ArrowRightIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-primary text-slate-300" data-id="element-37">
      {/* CTA Band */}
      <div className="border-b border-slate-800" data-id="element-38">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-id="element-39">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-40">
            <div className="max-w-2xl text-center md:text-left" data-id="element-41">
              <h2 className="text-3xl font-bold text-white mb-4" data-id="element-42">
                Ready to transform your waiting area?
              </h2>
              <p className="text-slate-400 text-lg" data-id="element-43">
                Join modern banks, hospitals, and service centers using
                ERPLogiFlow to deliver seamless customer experiences.
              </p>
            </div>
            <button className="bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-md font-bold text-lg transition-colors flex items-center gap-2 flex-shrink-0 shadow-lg shadow-accent/20" data-id="element-44">
              Request a Demo
              <ArrowRightIcon className="w-5 h-5" data-id="element-45" />
            </button>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-46">
        <div className="grid md:grid-cols-2 gap-8 mb-10" data-id="element-47">
          <div data-id="element-48">
            <div className="flex items-center gap-2 mb-4" data-id="element-49">
              <div className="w-8 h-8 rounded bg-white/10 flex items-center justify-center" data-id="element-50">
                <ActivityIcon className="w-5 h-5 text-white" data-id="element-51" />
              </div>
              <span className="font-bold text-xl text-white tracking-tight" data-id="element-52">
                ERPLogiFlow
              </span>
            </div>
            <p className="text-sm text-slate-400 max-w-sm leading-relaxed" data-id="element-53">
              Transforming waiting into seamless service — an intelligent token
              and progress management system by Indhri Group Pvt. Ltd.
            </p>
          </div>

          <div className="md:text-right" data-id="element-54">
            <h4 className="text-white font-semibold mb-4" data-id="element-55">Contact</h4>
            <address className="not-italic text-sm text-slate-400 space-y-1.5" data-id="element-56">
              <p data-id="element-57">Indhri Group Pvt. Ltd.</p>
              <p data-id="element-58">
                Birgunj-8, Opposite of Birat Hotel, Panitanki, Birgunj, Nepal
              </p>
              <p data-id="element-59">
                <a href="mailto:Info@indhrigroup.com" className="hover:text-white transition-colors" data-id="element-60">
                  Info@indhrigroup.com
                </a>
              </p>
              <p data-id="element-61">
                <a href="https://www.erplogiflow.com" className="hover:text-white transition-colors" data-id="element-62">
                  www.erplogiflow.com
                </a>
              </p>
              <p data-id="element-63">
                <a href="tel:+9779804237598" className="hover:text-white transition-colors" data-id="element-64">
                  +977 9804237598
                </a>
                {' · '}
                <a href="tel:+9779802059688" className="hover:text-white transition-colors" data-id="element-65">
                  +977 9802059688
                </a>
              </p>
            </address>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-6 text-center md:text-left text-sm text-slate-500" data-id="element-66">
          &copy; {new Date().getFullYear()} ERPLogiFlow. All rights reserved.
        </div>
      </div>
    </footer>;
}